import { Component, OnInit } from '@angular/core';


import { Router } from '@angular/router';

@Component({
  selector: 'app-claim-filter',
  templateUrl: './claim-filter.component.html',
  styleUrls: ['./claim-filter.component.css'],

})
export class ClaimFilterComponent implements OnInit {

  constructor(private router: Router) {

  }
  ngOnInit() {

  }
  outputData(e) {
    this.router.navigate(['/claim-list'], { queryParams: e });
  }
}